// @ts-nocheck
import * as addPanel from '@/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_comboboxinput'],
      sections: [addPanel.sections.getSections().developer.selectionSection],
    };
  },
};
